import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { fetchActivitiesWithExperience } from '../../../common/utils/analytics/utils';
import { ActivityClient } from '../base';
import { fetchActivitiesV2 } from './fetch-activities';
export class ActivityClientV2 extends ActivityClient {
  constructor(_product, baseUrl) {
    super('v2', _product, undefined, baseUrl);
    _defineProperty(this, "fetchActivities", async (retryMS, filters, activityQueries) => {
      return fetchActivitiesWithExperience(experience => fetchActivitiesV2({
        experience,
        product: this.product,
        retryMS,
        filters,
        activityQueries,
        baseUrl: this.baseUrl
      }), 'v2');
    });
    _defineProperty(this, "setProduct", product => {
      this.product = product;
    });
  }
}